export default __webpack_public_path__ + "assets/images/5c84cf6f06c6eb06f09ea11e146f2c9e.png";